<template>
    <div :class="{
      'flex items-center': canBeChecked,
    }">
        <label class="block text-white font-bold text-sm md:text-base">{{ label }}</label>
        <input :type="type"
               v-model="itemValue"
               class="w-full h-10 bg-white rounded-lg px-5 focus:outline-none"
               :class="{
                 'w-4 ml-2': canBeChecked,
                 'w-full px-1 py-2': !canBeChecked,
                 [inputClass]: true,
               }"
               ref="input"
               @keypress="$emit('keypress', $event)"
               v-bind="$attrs" />
        <div v-if="error"
             class="text-white text-sm mt-2 font-bold text-center"
             v-text="error"></div>
    </div>
</template>

<script>
export default {
    props: {
        value: {},
        type: {
            type: String,
            default: "text",
        },
        label: {},
        inputClass: {},
        error: {},
    },

    data() {
        return {
            itemValue: ""
        }
    },

    computed: {
        canBeChecked() {
            return this.type === 'radio' || this.type === 'checkbox';
        },
    },

    methods: {},

    watch: {
        itemValue(itemValue) {
            if (this.canBeChecked) {
                this.$emit('input', this.$refs.input.checked);
            } else {
                this.$emit('input', itemValue);
            }
        },

        value: {
            immediate: true,
            handler(value) {
                this.itemValue = value;
            }
        }
    },

    mounted() { }
};
</script>